import Image from "next/image";
import ContentFlagIcon from "@/shared/ContentFlagIcon";


const loader = ({ src, width }) => {
  return `${src}?w=${width}`;
};

const ContentImage = ({ data, iconMultimedia, alt="", classStyle, dataHero = false, image="/img/default.svg" }) => {
  
  const isWidth720 = data?.desktop?.width === 720;
  const isHeightLess200 = data?.desktop?.height < 200;
  const isHeight360 = data?.desktop?.height === 360;
  
  const calculatedHeight = isHeightLess200 && isWidth720 ? "480" : isHeightLess200 && isHeight360 ? "240" : data?.desktop?.height;

  return (
    <>
      <source
        media="(min-width: 975px)"
        width={data?.desktop?.width ?? "100"}
        height={calculatedHeight ?? "100"}
        srcSet={
          data?.desktop && data?.desktop.image != "#"
            ? data.desktop.image
            : image ? image : "/img/default.svg"
        }
      />
      <Image
        suppressHydrationWarning
        loader={loader}
        alt={alt}
        className={classStyle}
        src={
          data?.mobile && data?.mobile.image != "#"
            ? data?.mobile?.image
            : data?.desktop && data?.desktop.image != "#"
            ? data.desktop.image
            : image ? image : "/img/default.svg"
        }
        width={data?.mobile?.width ?? "100"}
        height={calculatedHeight ?? "100"}
        priority={dataHero}
        loading={!dataHero ? "eager" : undefined}
      />
      {iconMultimedia && <ContentFlagIcon nameIcon={iconMultimedia} />}
    </>

  );
};
export default ContentImage;
